import { put } from 'redux-saga/effects';

import { GeneratorResult, takeIf } from '@pressreader/appstore';
import { ArticleCollectionIds } from '@pressreader/social-types';

import {
    removeArticleFromCollectionsAction,
    removeArticleFromCollectionsDone,
    removeArticleFromCollectionsFailed,
    upsertArticleCollectionsAction,
    upsertArticleCollectionsDone,
    upsertArticleCollectionsFailed,
} from '../../actions';

function* upsertArticleCollectionsSaga(articleId: string, data: ArticleCollectionIds): GeneratorResult<void> {
    yield put(upsertArticleCollectionsAction({ articleId, collectionsData: data }));

    const { type } = yield takeIf([upsertArticleCollectionsDone, upsertArticleCollectionsFailed], action => {
        return action.payload.articleId === articleId;
    });

    if (type === String(upsertArticleCollectionsFailed)) {
        throw new Error('Failed to upsert article collections');
    }
}

function* removeArticleFromCollectionsSaga(articleId: string): GeneratorResult<void> {
    yield put(removeArticleFromCollectionsAction({ articleId }));

    const { type } = yield takeIf(
        [removeArticleFromCollectionsDone, removeArticleFromCollectionsFailed],
        action => action.payload.articleId === articleId,
    );

    if (type === String(removeArticleFromCollectionsFailed)) {
        throw new Error('Failed to remove article from collections');
    }
}

export { upsertArticleCollectionsSaga, removeArticleFromCollectionsSaga };
